import { cva } from "class-variance-authority";

export const AVATAR_SIZES = ["xs", "sm", "md", "lg", "xl", "2xl", "3xl", "full"] as const;

export type AvatarSize = (typeof AVATAR_SIZES)[number];

export const avatarVariants = cva("relative flex shrink-0 overflow-hidden rounded-full", {
  variants: {
    size: {
      xs: "size-5",
      sm: "size-6",
      md: "size-8",
      lg: "size-10",
      xl: "size-12",
      "2xl": "size-24",
      "3xl": "size-32",
      full: "size-full",
    },
  },
  defaultVariants: {
    size: "md",
  },
});

// Initials scale with the box, so the size variant spans both elements: the box classes land on the
// root, the text size on the fallback.
export const avatarFallbackVariants = cva("flex size-full items-center justify-center rounded-full font-semibold", {
  variants: {
    size: {
      xs: "text-[0.625rem]",
      sm: "text-xs",
      md: "text-sm",
      lg: "text-base",
      xl: "text-lg",
      "2xl": "text-3xl",
      "3xl": "text-4xl",
      full: "text-[4rem]",
    },
  },
  defaultVariants: {
    size: "md",
  },
});
